import { HubConnection } from "@microsoft/signalr";
import React from "react";

type UseReconnectArgs = {
  connection: HubConnection;
  connected: boolean;
  disabled?: boolean;
  onConnect: () => void;
  reconnectTime: number;
};

export function useReconnect({
  connection,
  connected,
  onConnect,
  reconnectTime,
  disabled = false,
}: UseReconnectArgs): void {
  // Manual reconnection, try reconnecting every X seconds
  React.useEffect(() => {
    const intervalId = setInterval(() => {
      if (!connected && !disabled) {
        connection
          .start()
          .then(onConnect)

          .catch(() => {});
      }
    }, reconnectTime);
    return () => {
      clearInterval(intervalId);
    };
  }, [connected, connection, disabled, onConnect, reconnectTime]);
}
